// extracted by mini-css-extract-plugin
export default {"editItemContainer":"styles_editItemContainer__+pKcp","editItemLabel":"styles_editItemLabel__UP+W6"};